import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setUserInfo } from '../redux/actions';
import { RootState } from '../redux/reducers';
import { setLoading } from '../redux/slices/appInfo';
import { getUserInfo } from '../api/auth';

export const useMe = () => {
    const dispatch = useDispatch();
    const userInfo = useSelector((state: RootState) => state.userInfo);
    const token = useMemo(() => userInfo?.token, [userInfo]);

    const getMe = React.useCallback(async () => {
        dispatch(setLoading(true));
        try {
            const result = await getUserInfo();
            if (result.status === 200) {
                const newUserInfo = {
                    ...userInfo,
                    ...result.data?.data,
                };
                dispatch(setUserInfo(newUserInfo));
            }
        } catch (e) {
            // Handle error
        } finally {
            dispatch(setLoading(false));
        }
    }, [dispatch]);

    return {
        getMe,
        token,
    };
};
